import { DEFAULT_BRAND_IMAGES } from './brandImages';

export const NAV_ITEMS = [
  { id: 'home', label: 'Inicio' },
  { id: 'howItWorks', label: 'Cómo funciona' },
  { id: 'benefits', label: 'Beneficios' },
  { id: 'canjes', label: 'Canjes' },
  { id: 'help', label: 'Ayuda' },
];

export const MEMBER_NAV_ITEMS = [
  { id: 'home',       label: 'Inicio' },
  { id: 'canjes',     label: 'Canjes' },
  { id: 'history',    label: 'Mis puntos' },
  { id: 'howItWorks', label: 'Cómo funciona' },
  { id: 'help',       label: 'Ayuda' },
];

export const HOW_IT_WORKS_STEPS = [
  {
    title: '1. Registrate',
    text: 'Creá tu cuenta gratis en Maja Club. Es rápido, fácil y sin costo.',
  },
  {
    title: '2. Sumá puntos',
    text: 'Cada vez que disfrutás en Maja Morena, sumás puntos con tus compras.',
  },
  {
    title: '3. Canjeá beneficios',
    text: 'Convertí tus puntos en promos, productos y experiencias exclusivas.',
  },
  {
    title: '4. Disfrutá sorpresas',
    text: 'Hay mucho más para seguir disfrutando juntos: sorteos, cumpleaños y beneficios especiales.',
  },
];

export const FEATURED_BENEFITS = [
  {
    title: 'Martes de empanadas 3x2',
    text: 'Más sabor, más encuentros.',
    imageKey: 'destacado1',
  },
  {
    title: 'Cumple con sorpresa',
    text: 'Tu día también sabe mejor en Maja Morena.',
    imageKey: 'destacado2',
  },
  {
    title: 'Premios por puntos',
    text: 'Canjeá productos, experiencias y mucho más.',
    imageKey: 'destacado3',
  },
  {
    title: 'Promos exclusivas',
    text: 'Solo para miembros de Maja Club.',
    imageKey: 'destacado4',
  },
  {
    title: 'Canjeá vouchers',
    text: 'Beneficios pensados para vivir más momentos.',
    imageKey: 'destacado5',
  },
  {
    title: 'Momentos para compartir',
    text: 'Experiencias pensadas para disfrutar en Maja Morena.',
    imageKey: 'destacado6',
  },
];

export const BENEFIT_CATEGORIES = [
  { id: 'all', label: 'Todos' },
  { id: 'descuento', label: 'Promociones' },
  { id: 'producto', label: 'Productos' },
  { id: 'experiencia', label: 'Experiencias' },
  { id: 'servicio', label: 'Servicios' },
];

export const FAQ_TOPICS = [
  {
    id: 'ingreso',
    title: 'Ingreso y registro',
    body: 'Creá tu cuenta con email y contraseña. Si ya sos miembro, iniciá sesión desde el botón Iniciar sesión. Si olvidaste la clave, podés recuperarla en esa misma pantalla.',
  },
  {
    id: 'puntos',
    title: 'Puntos y acumulación',
    body: 'Sumás puntos cada vez que comprás en sucursales adheridas. El operador carga tu consumo y los puntos se acreditan en tu cuenta.',
  },
  {
    id: 'canjes',
    title: 'Canjes y recompensas',
    body: 'En Canjes ves el catálogo disponible. Si tenés puntos suficientes, confirmás el canje y se genera un voucher para usar en el local.',
  },
  {
    id: 'cumple',
    title: 'Cumpleaños',
    body: 'Completá tu fecha de nacimiento en el registro. Cuando se acerca tu cumple, el club puede activar beneficios especiales.',
  },
  {
    id: 'vouchers',
    title: 'Vouchers y promociones',
    body: 'Los vouchers quedan en tu historial. Mostralos en caja antes de que vencen. El estado puede ser pendiente o ya utilizado.',
  },
  {
    id: 'cuenta',
    title: 'Cuenta y datos personales',
    body: 'En Mi cuenta ves tu nombre, DNI, teléfono y domicilio. Si necesitás corregir un dato, escribinos por WhatsApp.',
  },
];

export const FALLBACK_LOCALES = [
  { nombre: 'Villa Carlos Paz — Libertad', direccion: 'Av. Libertad esq. Florida', telefono: '03541 422023' },
  { nombre: 'Villa Carlos Paz — Cárcano', direccion: 'Av. Cárcano esq. Int. García', telefono: '03541 423589' },
  { nombre: 'Villa Carlos Paz — Sarmiento', direccion: 'Bv. Sarmiento 171', telefono: '03541 422595' },
  { nombre: 'Villa Carlos Paz — San Martín y Artigas', direccion: 'San Martín esq. Artigas', telefono: '03541 433434' },
  { nombre: 'Villa Carlos Paz — San Martín 58', direccion: 'San Martín 58', telefono: '3541 543969' },
  { nombre: 'Alta Gracia', direccion: 'España esq. Urquiza', telefono: '03547 432841' },
  { nombre: 'Río Cuarto — San Martín', direccion: 'San Martín 970', telefono: '0358 4655500' },
  { nombre: 'Río Cuarto — Italia', direccion: 'Av. Italia 1311', telefono: '0358 5602477' },
  { nombre: 'Córdoba Capital', direccion: 'Terminal de ómnibus', telefono: '' },
  { nombre: 'Tanti', direccion: 'Ruta 28 esq. Italia', telefono: '3541 327786' },
  { nombre: 'Morteros', direccion: 'Blvd. Belgrano 1001', telefono: '3562 501061' },
  { nombre: 'Cosquín', direccion: 'Av. San Martín 769', telefono: '3541 238438' },
  { nombre: 'Santa Cruz del Lago', direccion: 'Av. Argentina', telefono: '3514 293743' },
  { nombre: 'Mendiolaza', direccion: 'Av. Martín Tissera 3693', telefono: '351 7627222' },
];

export const DEFAULT_SITE_CONTACT = {
  whatsapp: '5493541543969',
  email: '',
  telefono: '',
  instagram: 'https://www.instagram.com/majamorenaempanadas/',
  facebook: 'https://www.facebook.com/',
  tiktok: 'https://www.tiktok.com/',
  youtube: 'https://www.youtube.com/',
};

export const DEFAULT_SITE_IMAGES = DEFAULT_BRAND_IMAGES;
